import React from 'react';

import { NavLink } from 'react-router-dom';

import { AppRoute } from '@app/components/LocalCommon/const';
import { pushEvent } from '@app/components/TagManager';
import ContactUs from '@app/components/UI/ContactUs/ContactUs';
import FooterMenu from '@app/components/UI/Footer/FooterMenu';
import CustomModal from '@app/components/UI/Modal/CustomModal';
import PHJLogoSVG from '@app/images/PHJLogoSVG';
import IconTikTok from '@app/images/social/IconTikTok';
import IconTwitter from '@app/images/social/IconTwitter';
import iconFacebook from '@app/images/social/icon_facebook.svg';
import iconInstagram from '@app/images/social/icon_instagram.svg';
import iconLinkedin from '@app/images/social/icon_linkedin.svg';
import iconYoutube from '@app/images/social/icon_youtube.svg';
import '@app/scss/footer.scss';

const year = new Date().getFullYear();

const Footer: React.FC = () => {
	const [openContactForm, setOpenContactForm] = React.useState<boolean>(false);

	return (
		<>
			<footer className="site-footer">
				<div className="site-footer-wrapper">
					<div className="site-footer-body">
						<div className="site-footer-body__left">
							<div className="site-footer-body__left-phj">
								<div className="site-footer-body__left-phj-logo">
									<NavLink to="/">
										<PHJLogoSVG fill="#9c8caf" />
									</NavLink>
								</div>
								<div className="site-footer-body__left-phj-nav">
									<ul>
										<li>
											<NavLink to={AppRoute.USING_PHJ}>
												Using Pet Hospice Journal
											</NavLink>
										</li>
										<li>
											<NavLink to={AppRoute.ABOUT}>
												About the Journal
											</NavLink>
										</li>
										<li>
											<span onClick={() => setOpenContactForm(true)}>
												Contact PHJ Support
											</span>
										</li>
									</ul>
								</div>
							</div>
							<div className="site-footer-body__left-lol">
								<a href="https://www.lapoflove.com" target="_blank" rel="noopener noreferrer">
									<img className="site-footer-body__logo" src={require('@app/images/logo_glyph_light.svg')} alt="Logo" />
								</a>
								<FooterMenu />
							</div>
						</div>
						<div className="site-footer-contacts">
							<div className="site-footer-contacts__schedule">
								<p>For individual advice from a Lap of Love veterinarian on caring for your hospice pet…</p>
								<a
									className="btn btn-purple-gray btn-not-mobile"
									href="https://www.lapoflove.com/online-booking"
									target="_blank"
									rel="noopener noreferrer"
									onClick={() => pushEvent('PHJ-ScheduleFooter')}
								>
									Schedule an Appointment
								</a>
								<a
									className="btn btn-purple-gray btn-mobile"
									href="https://www.lapoflove.com/online-booking"
									target="_blank"
									rel="noopener noreferrer"
									onClick={() => pushEvent('PHJ-MobileScheduleFooter')}
								>
									Schedule an Appointment
								</a>
							</div>
							<h4 className="site-footer-contacts__title">
								<a
									className="site-footer-contacts__link"
									href="https://info.lapoflove.com/senior-pet-digest"
									target="_blank"
									rel="noopener noreferrer"
								>
									Subscribe
								</a>
								<span>Subscribe</span>
								{' '}
								to the Senior Pet Digest
							</h4>
							<p className="site-footer-contacts__text">
								<span>
									<a
										className="site-footer-contacts__link"
										href="https://info.lapoflove.com/senior-pet-digest"
										target="_blank"
										rel="noopener noreferrer"
									>
										Subscribe here
									</a>
									&nbsp; to view our monthly newsletter with helpful pet articles, insights, and resources.
								</span>
								<span className="mobile">To receive our monthly newsletter containing helpful articles and resources on senior pet care.</span>
							</p>
							<FooterMenu isMobile />
							<div className="site-footer-contacts-connect">
								<img className="site-footer-contacts-connect__logo" src={require('@app/images/logo_glyph_light.svg')} alt="Logo" />
								<div className="social-block">
									<b>Connect with us:</b>
									<div className="social-block-list">
										<a href="https://www.facebook.com/lapoflove" target="_blank" rel="noopener noreferrer">
											<img className="social-link" src={iconFacebook} alt="Facebook" />
										</a>
										<a href="https://twitter.com/LapofLoveVets" target="_blank" rel="noopener noreferrer" className="twitter">
											<IconTwitter />
										</a>
										<a href="https://www.instagram.com/lapofloveveterinaryhospice/" target="_blank" rel="noopener noreferrer">
											<img className="social-link" src={iconInstagram} alt="Instagram" />
										</a>
										<a href="https://www.youtube.com/user/Lapoflove" target="_blank" rel="noopener noreferrer">
											<img className="social-link" src={iconYoutube} alt="Youtube" />
										</a>
										<a
											href="https://www.linkedin.com/company/lap-of-love-veterinary-hospice"
											target="_blank"
											rel="noopener noreferrer"
										>
											<img className="social-link" src={iconLinkedin} alt="Linkedin" />
										</a>
										<a href="https://www.tiktok.com/@lapoflovevets" target="_blank" rel="noopener noreferrer">
											<div className="social-link tiktok">
												<IconTikTok />
											</div>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="site-footer-bottom">
						<span className="site-footer-bottom__copyright">
							{`© 2010-${year} Lap of Love. All rights reserved.`}
						</span>
						<div className="site-footer-bottom__policies">
							<a href="https://www.lapoflove.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer">
								Privacy Policy
							</a>
							<a href="https://www.lapoflove.com/policies/terms-and-conditions" target="_blank" rel="noopener noreferrer">
								Terms and Conditions
							</a>
							<a href="https://www.lapoflove.com/policies/accessibility-policy" target="_blank" rel="noopener noreferrer">
								Accessibility Policy
							</a>
						</div>
					</div>
				</div>
			</footer>

			{openContactForm && (
				<CustomModal modalVisible={openContactForm} setModalVisible={setOpenContactForm}>
					<ContactUs onChangeVisibleModal={setOpenContactForm} />
				</CustomModal>
			)}
		</>
	);
};

export default Footer;
